import { OffHireType } from '../graphql';
import startCase from 'lodash/startCase';

export const offHireTypes: Array<{
  id: OffHireType;
  name: string;
}> = Object.keys(OffHireType).map((val) => ({
  id: val as OffHireType,
  name: startCase(val),
}));
